module.exports = __webpack_public_path__ + "img/tutorial_ten_fr.2d6cedca.png";